import React, {useMemo} from 'react'
import {useGetPageByType} from '../../custom-api/hooks/use-get-page-by-type'
import RenderComponents from '../../components/editorial-components/render-components'
import Skeleton from '../editorial/skeleton'
import {Box} from '@chakra-ui/react'
import AlternateMetaTag from '../../components/metatag/alternate'
import {getSites} from '../../utils/site-utils'
import {Helmet} from 'react-helmet'

const Home = () => {
    const {data, isFetching, isLoading, isSuccess, isError} = useGetPageByType('home_page')
    const entries = {...data}
    const sites = getSites()

    const links = useMemo(() => {
        return sites
            .map((site) =>
                site.l10n.supportedLocales.map((locale) => {
                    return {
                        hreflang: locale.alias,
                        url: `/${locale.alias}`,
                    }
                }),
            )
            ?.flat()
    }, [])

    const seo = entries?.seo_standard || {}
    const metaTitle = seo?.meta_title
    const metaDescription = seo?.meta_description

    return (
        <Box data-gtm={'homepage'} id="homepage">
            <AlternateMetaTag links={links} />

            <Helmet>
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
            </Helmet>

            {(isFetching || isLoading) &&
                Array(entries?.editorial_components?.length || 4)
                    .fill()
                    .map((_, index) => <Skeleton key={index} />)}

            {isSuccess && !!Object.keys(entries).length && (
                <RenderComponents
                    pageComponents={entries?.editorial_components}
                    contentTypeUid="page"
                    entryUid={entries?.uid}
                    locale={entries?.locale}
                    isFetching={isFetching}
                />
            )}

            {isError && <>{/* handle error */}</>}
        </Box>
    )
}

Home.getTemplateName = () => 'home'

export default Home
